import {
  MAX_CHARACTERS_COPY,
  REQUIRED_INPUT_COPY,
  REQUIRED_SELECTION_COPY,
} from 'src/components/organisms/Personalisation/constants/copy';
import {
  FieldEvent,
  FieldEventInteractionAction,
  FieldEventProgressMilestoneAction,
  ProductEvent,
} from 'src/types';

export const PRODUCT_PERSONALISATIONS_VISIBILITY_NAME = 'productPersonalisations';

export type PersonalisationInitialImpression = ProductEvent<
  'custom_event',
  'Impression',
  'Initial Impression'
>;

export type PersonalisationExpanded = ProductEvent<
  'custom_event',
  'Impression',
  'Expand personalisation'
>;

export type PersonalisationInteractionFieldEvent = FieldEvent<FieldEventInteractionAction>;
export type PersonalisationProgressFieldEvent = FieldEvent<FieldEventProgressMilestoneAction>;

export type AddToCartError = FieldEvent<
  'Add to Cart Error',
  typeof REQUIRED_SELECTION_COPY | typeof REQUIRED_INPUT_COPY,
  null
>;
export type InputError = FieldEvent<'Character Limit Error', typeof MAX_CHARACTERS_COPY, null>;

export type PersonalisationErrorFieldEvent = AddToCartError | InputError;
